// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import Paper from '@/modules/common/components/Paper';
import Button from '@/modules/common/components/Button';
import Content from '@/modules/common/components/Content';
import Spinner from '@/modules/common/components/Spinner';
import Pagination from '@/modules/common/components/Pagination';
import ErrorFetch from '@/modules/common/components/ErrorFetch';
import ContentBody from '@/modules/common/components/ContentBody';
import ContentHeader from '@/modules/common/components/ContentHeader';
import ContentBodyTop from '@/modules/common/components/ContentBodyTop';
import { withFetch } from '~/hocs/fetch';
import { withRouter } from '~/hocs/router';
import Table from './Table';
import DialogAdd from './DialogAdd';
import DialogEdit from './DialogEdit';
import ContextMenu from './ContextMenu';
import DialogDelete from './DialogDelete';
import '../styles/AutoStatuses.scss';

let abortController;

const AutoStatuses = (props) => {
    const offerName = props.match.params.offerName;
    const breadcrumbs = [
        {name: 'Офферы', to: '/offers/'},
        {name: offerName, to: `/offers/${offerName}/`},
        {name: 'Автоматические статусы'},
    ];

    const { enqueueSnackbar } = useSnackbar();

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [selectedAutoStatus, setSelectedAutoStatus] = useState(null);
    const [openDialogAdd, setOpenDialogAdd] = useState(false);
    const [openDialogEdit, setOpenDialogEdit] = useState(false);
    const [openDialogDelete, setOpenDialogDelete] = useState(false);
    const [positionContextMenu, setPositionContextMenu] = useState({left: null, top: null});

    const fetch = () => {
        abortController = new AbortController();
        setLoading(true);
        props.fetch.get(`/api/auto-statuses/?offer_name=${offerName}`, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    setData(data);
                }
                setLoading(false);
            })
            .catch((error) => {
                setData(null);
                if (error.name !== 'AbortError') {
                    setLoading(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    const closeContextMenu = () => {
        setPositionContextMenu({left: null, top: null});
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    useEffect(() => {
        let page = parseInt(props.router.urlSearchParams.get('page'));

        if (isNaN(page)) {
            page = 1;
        }
        // noinspection JSCheckFunctionSignatures
        props.router.urlSearchParams.set('page', page);

        fetch();
    }, [props.history.location.search]);

    /******************************************************************************************************************/

    const handleContextMenu = (autoStatus) => (event) => {
        event.preventDefault();
        setSelectedAutoStatus(autoStatus);
        setPositionContextMenu({left: event.clientX, top: event.clientY});
    };

    const handleClickEdit = () => {
        closeContextMenu();
        setOpenDialogEdit(true);
    };

    const handleClickDelete = () => {
        closeContextMenu();
        setOpenDialogDelete(true);
    };

    const handleCloseContextMenu = () => {
        closeContextMenu();
        setSelectedAutoStatus(null);
    };

    /******************************************************************************************************************/

    const handleAddOk = () => {
        setOpenDialogAdd(false);
        props.router.reload();
        enqueueSnackbar('Автоматический статус добавлен', {variant: 'success'});
    };

    const handleEditOk = () => {
        setOpenDialogEdit(false);
        setSelectedAutoStatus(null);
        props.router.reload();
        enqueueSnackbar('Автоматический статус изменен', {variant: 'success'});
    };

    const handleDeleteOk = () => {
        setOpenDialogDelete(false);
        setSelectedAutoStatus(null);
        props.router.reload();
        enqueueSnackbar('Автоматический статус удален', {variant: 'success'});
    };

    /******************************************************************************************************************/

    // noinspection JSUnresolvedVariable
    return (
        <Content id="auto-statuses">
            <ContentHeader breadcrumbs={breadcrumbs}/>
            <ContentBody><Paper>
                {(!loading)
                    ? <>
                        {(data && data.results)
                            ? <>
                                <ContentBodyTop left={
                                    <Button onClick={() => setOpenDialogAdd(true)}>Добавить</Button>
                                }/>
                                <DialogAdd open={openDialogAdd} setOpen={setOpenDialogAdd} onOk={handleAddOk}/>
                                {(data.results.length > 0)
                                    ? <>
                                        <Table autoStatuses={data.results} selectedAutoStatus={selectedAutoStatus}
                                               onContextMenu={handleContextMenu}
                                        />
                                        <ContextMenu position={positionContextMenu}
                                                     onClickEdit={handleClickEdit}
                                                     onClickDelete={handleClickDelete}
                                                     onClose={handleCloseContextMenu}
                                        />
                                        <DialogEdit selectedAutoStatus={selectedAutoStatus}
                                                    setSelectedAutoStatus={setSelectedAutoStatus}
                                                    open={openDialogEdit} setOpen={setOpenDialogEdit}
                                                    onOk={handleEditOk}
                                        />
                                        <DialogDelete selectedAutoStatus={selectedAutoStatus}
                                                      setSelectedAutoStatus={setSelectedAutoStatus}
                                                      open={openDialogDelete} setOpen={setOpenDialogDelete}
                                                      onOk={handleDeleteOk}
                                        />
                                        <Pagination totalPages={data.total_pages} currentPage={data.current_page}/>
                                    </>
                                    : null
                                }
                            </>
                            : <ErrorFetch onClick={() => fetch()}/>
                        }
                    </>
                    : <Spinner/>
                }
            </Paper></ContentBody>
        </Content>
    );
};

let Component = AutoStatuses;
Component = withRouter(Component);
Component = withFetch(Component);

export default Component;

